<template>
  <CRow>
    <CCol col="12" lg="12">
      <CCard>
        <CCardBody>
            <h3 v-if="isEditing">
                {{ $t('button.edit') }} {{ $tc('roles.label', 1) }}
            </h3>
            <h3 v-else>{{ $t('button.create') }} {{ $tc('roles.label', 1) }}</h3>
            <div class="row">
                <div class="col-6">
                    <CInput :label="$t('fields.name')" type="text" placeholder="Ex: role name" v-model="role.name"/>
                </div>
            </div>
            <h3>{{ $t('roles.fields.permissions') }}</h3>
            <div class="row">
              <!-- clients -->
              <div class="col-3">
                <h4>{{ $tc('clients.label', 2) }}</h4>
                <CInputCheckbox
                  :label="$t('permissions.browse')"
                  value="true"
                  :checked="role.permissions.clients.browse"
                  @update:checked="selectCheckbox('browse', 'clients')"
                />
                <CInputCheckbox
                  :label="$t('permissions.view')"
                  value="true"
                  :checked="role.permissions.clients.read"
                  @update:checked="selectCheckbox('read', 'clients')"
                />
                <CInputCheckbox
                  :label="$t('permissions.add')"
                  value="true"
                  :checked="role.permissions.clients.add"
                  @update:checked="selectCheckbox('add', 'clients')"
                />
                <CInputCheckbox
                  :label="$t('permissions.edit')"
                  value="true"
                  :checked="role.permissions.clients.edit"
                  @update:checked="selectCheckbox('edit', 'clients')"
                />
                <CInputCheckbox
                  :label="$t('permissions.delete')"
                  value="true"
                  :checked="role.permissions.clients.delete"
                  @update:checked="selectCheckbox('delete', 'clients')"
                  class="mb-2"
                />
                <CInputCheckbox
                  :label="$t('permissions.browse_followup')"
                  value="true"
                  :checked="role.permissions.followup.browse"
                  @update:checked="selectCheckbox('browse', 'followup')"
                />
              </div>
              <!-- orders -->
              <div class="col-3">
                <h4>{{ $tc('orders.label', 2) }}</h4>
                <CInputCheckbox
                  :label="$t('permissions.browse')"
                  value="true"
                  :checked="role.permissions.orders.browse"
                  @update:checked="selectCheckbox('browse', 'orders')"
                />
                <CInputCheckbox
                  :label="$t('permissions.view')"
                  value="true"
                  :checked="role.permissions.orders.read"
                  @update:checked="selectCheckbox('read', 'orders')"
                />
                <CInputCheckbox
                  :label="$t('permissions.add')"
                  value="true"
                  :checked="role.permissions.orders.add"
                  @update:checked="selectCheckbox('add', 'orders')"
                />
                <CInputCheckbox
                  :label="$t('permissions.edit')"
                  value="true"
                  :checked="role.permissions.orders.edit"
                  @update:checked="selectCheckbox('edit', 'orders')"
                />
                <CInputCheckbox
                  :label="$t('permissions.delete')"
                  value="true"
                  :checked="role.permissions.orders.delete"
                  @update:checked="selectCheckbox('delete', 'orders')"
                  class="mb-2"
                />
              </div>
              <!-- employees -->
              <div class="col-3">
                <h4>{{ $tc('employees.label', 2) }}</h4>
                <CInputCheckbox
                  :label="$t('permissions.browse')"
                  value="true"
                  :checked="role.permissions.employees.browse"
                  @update:checked="selectCheckbox('browse', 'employees')"
                />
                <CInputCheckbox
                  :label="$t('permissions.view')"
                  value="true"
                  :checked="role.permissions.employees.read"
                  @update:checked="selectCheckbox('read', 'employees')"
                />
                <CInputCheckbox
                  :label="$t('permissions.add')"
                  value="true"
                  :checked="role.permissions.employees.add"
                  @update:checked="selectCheckbox('add', 'employees')"
                />
                <CInputCheckbox
                  :label="$t('permissions.edit')"
                  value="true"
                  :checked="role.permissions.employees.edit"
                  @update:checked="selectCheckbox('edit', 'employees')"
                />
                <CInputCheckbox
                  :label="$t('permissions.delete')"
                  value="true"
                  :checked="role.permissions.employees.delete"
                  @update:checked="selectCheckbox('delete', 'employees')"
                  class="mb-2"
                />
              </div>
              <!-- drivers -->
              <div class="col-3">
                <h4>{{ $tc('drivers.label', 2) }}</h4>
                <CInputCheckbox
                  :label="$t('permissions.browse')"
                  value="true"
                  :checked="role.permissions.drivers.browse"
                  @update:checked="selectCheckbox('browse', 'drivers')"
                />
                <CInputCheckbox
                  :label="$t('permissions.view')"
                  value="true"
                  :checked="role.permissions.drivers.read"
                  @update:checked="selectCheckbox('read', 'drivers')"
                />
                <CInputCheckbox
                  :label="$t('permissions.add')"
                  value="true"
                  :checked="role.permissions.drivers.add"
                  @update:checked="selectCheckbox('add', 'drivers')"
                />
                <CInputCheckbox
                  :label="$t('permissions.edit')"
                  value="true"
                  :checked="role.permissions.drivers.edit"
                  @update:checked="selectCheckbox('edit', 'drivers')"
                />
                <CInputCheckbox
                  :label="$t('permissions.delete')"
                  value="true"
                  :checked="role.permissions.drivers.delete"
                  @update:checked="selectCheckbox('delete', 'drivers')"
                  class="mb-2"
                />
              </div>
            </div>
            <div class="row">
              <!-- products -->
              <div class="col-3">
                <h3>{{ $tc('delivery_types.label', 2) }}</h3>
                <CInputCheckbox
                  :label="$t('permissions.browse')"
                  value="true"
                  :checked="role.permissions.delivery_types.browse"
                  @update:checked="selectCheckbox('browse', 'delivery_types')"
                />
                <CInputCheckbox
                  :label="$t('permissions.view')"
                  value="true"
                  :checked="role.permissions.delivery_types.read"
                  @update:checked="selectCheckbox('read', 'delivery_types')"
                />
                <CInputCheckbox
                  :label="$t('permissions.add')"
                  value="true"
                  :checked="role.permissions.delivery_types.add"
                  @update:checked="selectCheckbox('add', 'delivery_types')"
                />
                <CInputCheckbox
                  :label="$t('permissions.edit')"
                  value="true"
                  :checked="role.permissions.delivery_types.edit"
                  @update:checked="selectCheckbox('edit', 'delivery_types')"
                />
                <CInputCheckbox
                  :label="$t('permissions.delete')"
                  value="true"
                  :checked="role.permissions.delivery_types.delete"
                  @update:checked="selectCheckbox('delete', 'delivery_types')"
                  class="mb-2"
                />
                <CInputCheckbox
                  :label="$t('permissions.delivery_history')"
                  value="true"
                  :checked="role.permissions.delivery_history.browse"
                  @update:checked="selectCheckbox('browse', 'delivery_history')"
                />
              </div>
              <!-- report -->
              <div class="col-3">
                <h4>{{ $tc('reports.label', 2) }}</h4>
                <CInputCheckbox
                  :label="$t('permissions.browse')"
                  value="true"
                  :checked="role.permissions.reports.browse"
                  @update:checked="selectCheckbox('browse', 'reports')"
                />
                <CInputCheckbox
                  :label="$t('permissions.view')"
                  value="true"
                  :checked="role.permissions.reports.read"
                  @update:checked="selectCheckbox('read', 'reports')"
                />
                <CInputCheckbox
                  :label="$t('permissions.add')"
                  value="true"
                  :checked="role.permissions.reports.add"
                  @update:checked="selectCheckbox('add', 'reports')"
                />
                <CInputCheckbox
                  :label="$t('permissions.edit')"
                  value="true"
                  :checked="role.permissions.reports.edit"
                  @update:checked="selectCheckbox('edit', 'reports')"
                />
                <CInputCheckbox
                  :label="$t('permissions.delete')"
                  value="true"
                  :checked="role.permissions.reports.delete"
                  @update:checked="selectCheckbox('delete', 'reports')"
                  class="mb-2"
                />
              </div>
              <!-- expenses -->
              <div class="col-3">
                <h4>{{ $tc('expenses.label', 2) }}</h4>
                <CInputCheckbox
                  :label="$t('permissions.browse')"
                  value="true"
                  :checked="role.permissions.expenses.browse"
                  @update:checked="selectCheckbox('browse', 'expenses')"
                />
                <CInputCheckbox
                  :label="$t('permissions.view')"
                  value="true"
                  :checked="role.permissions.expenses.read"
                  @update:checked="selectCheckbox('read', 'expenses')"
                />
                <CInputCheckbox
                  :label="$t('permissions.add')"
                  value="true"
                  :checked="role.permissions.expenses.add"
                  @update:checked="selectCheckbox('add', 'expenses')"
                />
                <CInputCheckbox
                  :label="$t('permissions.edit')"
                  value="true"
                  :checked="role.permissions.expenses.edit"
                  @update:checked="selectCheckbox('edit', 'expenses')"
                />
                <CInputCheckbox
                  :label="$t('permissions.delete')"
                  value="true"
                  :checked="role.permissions.expenses.delete"
                  @update:checked="selectCheckbox('delete', 'expenses')"
                  class="mb-2"
                />
              </div>
              <!-- expense types -->
              <div class="col-3">
                <h4>{{ $tc('expense_types.label', 2) }}</h4>
                <CInputCheckbox
                  :label="$t('permissions.browse')"
                  value="true"
                  :checked="role.permissions.expense_types.browse"
                  @update:checked="selectCheckbox('browse', 'expense_types')"
                />
                <CInputCheckbox
                  :label="$t('permissions.view')"
                  value="true"
                  :checked="role.permissions.expense_types.read"
                  @update:checked="selectCheckbox('read', 'expense_types')"
                />
                <CInputCheckbox
                  :label="$t('permissions.add')"
                  value="true"
                  :checked="role.permissions.expense_types.add"
                  @update:checked="selectCheckbox('add', 'expense_types')"
                />
                <CInputCheckbox
                  :label="$t('permissions.edit')"
                  value="true"
                  :checked="role.permissions.expense_types.edit"
                  @update:checked="selectCheckbox('edit', 'expense_types')"
                />
                <CInputCheckbox
                  :label="$t('permissions.delete')"
                  value="true"
                  :checked="role.permissions.expense_types.delete"
                  @update:checked="selectCheckbox('delete', 'expense_types')"
                  class="mb-2"
                />
              </div>
              <!-- settings -->
              <div class="col-3">
                <h4>{{ $t('settings.label') }}</h4>
                <CInputCheckbox
                  :label="$t('permissions.browse')"
                  value="true"
                  :checked="role.permissions.settings.browse"
                  @update:checked="selectCheckbox('browse', 'settings')"
                />
                <CInputCheckbox
                  :label="$t('permissions.edit')"
                  value="true"
                  :checked="role.permissions.settings.edit"
                  @update:checked="selectCheckbox('edit', 'settings')"
                />
              </div>
            </div>
          <CButton color="success" @click="saveData">
            <template v-if="isEditing"> {{ $t('button.update') }}</template>
            <template v-else> {{ $t('button.create') }}</template>
          </CButton>
          <CButton color="primary" @click="goBack"> {{ $t('button.back') }}</CButton>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import axios from 'axios';
import formMixin from "../../mixins/form";
import localeMixin from '../../mixins/locale'; // Order matters, mixin first then i18n.
import i18n from "../../i18n";

export default {
  name: 'FormRole',
  mixins: [formMixin, localeMixin],
  data() {
    return {
        role: {
          name: '',
          permissions: {
            clients: {},
            followup: {},
            orders: {},
            employees: {},
            delivery_types: {},
            delivery_history: {},
            reports: {},
            drivers: {},
            expenses: {},
            expense_types: {},
            settings: {}
          },
          allPermissions: []
        },
        selectedPermissions: [],
    }
  },
  mounted() {
    if (this.isEditing) {
        this.getRole();
    }
  },
  methods: {
    goBack() {
      this.$router.push({ name: "Roles" });
    },
    selectCheckbox(slug, type) {
        const current_permission = type+'_'+slug;
        // toggle value
        const val = !this.role.permissions[type][slug]
        this.role.permissions[type][slug] =  val;
        if (val) {
          const perm = this.selectedPermissions.find(p => p === current_permission);
          if (!perm) {
            this.selectedPermissions.push(current_permission);
          }
        } else {
          this.selectedPermissions = this.selectedPermissions.filter(f => f !== current_permission);
        }
    },
    showAlert(type, msg) {
      let title = '';
      let body = '';
      let status = '';
      let redirect = true;

      switch(type) {
        case 'add':
          title = i18n.t('roles.modal.created_label');
          body = i18n.t('roles.modal.created_body');
          status = 'success';
          break;
        case 'edit':
          title = i18n.t('roles.modal.updated_label');
          body = i18n.t('roles.modal.updated_body');
          status = 'success';
          break;
        case 'error':
          title = 'Error';
          body = msg;
          status = 'danger';
          redirect = false;
          break;
      }

      this.$swal(
        title,
        body,
        status
      ).then(result => {
        if (redirect) {
          this.goBack();
        }
      });
    },
    saveData() {
        // const data = formData || this.prepareObjectData();
        const data = this.role;
        this.role.allPermissions = this.selectedPermissions;
        this.$emit("saved", data);
        let url = `/api/roles`;
        let sendRequest = null;

        if (this.isEditing) {
            url = url + "/" + this.$route.params.id + '?token=' + localStorage.getItem("api_token");
            sendRequest = async() => {
                try {
                    const response = await axios.put(url, data);
                    if (response.data.status === "success") {
                        this.showAlert('edit');
                    }
                } catch (error) {
                    if(error.response.data.message == 'The given data was invalid.'){
                        this.message = '';
                        for (let key in error.response.data.errors) {
                            if (error.response.data.errors.hasOwnProperty(key)) {
                                this.message += error.response.data.errors[key][0] + '<br>';
                            }
                        }
                        this.showAlert('error', this.message);
                    } else{
                        console.log(error);
                        this.$router.push({ path: '/login' }); 
                    }
                }
            };
        } else {
            url = url + '?token=' + localStorage.getItem("api_token");
                    console.log(data);
                    console.log(url);
            sendRequest = async() => {
                try {
                    console.log(data);
                    console.log(url);
                    const response = await axios.post(url, data);
                    if (response.data.status === "success") {
                        this.message = 'Successfully created employee.';
                        this.showAlert('add');
                    }
                    console.log(response);
                } catch (error) {
                    if(error.response.data.message == 'The given data was invalid.'){
                        this.message = '';
                        for (let key in error.response.data.errors) {
                            if (error.response.data.errors.hasOwnProperty(key)) {
                                this.message += error.response.data.errors[key][0] + '<br>';
                            }
                        }
                        this.showAlert('error', this.message);
                    } else{
                        console.log(error);
                        this.$router.push({ path: '/login' }); 
                    }
                }
            };
        }
        console.log(sendRequest);
        sendRequest();
        return data;
    },
    getRole() {
        const id = this.$route.params.id;
        axios.get('/api/roles/' + id + '/edit?token=' + localStorage.getItem("api_token"))
        .then(response => {
            this.role = response.data;
            this.selectedPermissions = response.data.allPermissions;
            // console.log(this.selectedPermissions);
        }).catch(error => {
            console.log(error);
            this.$router.push({ path: '/login' });
        });
    }
  }
}

</script>
